import React from "react";

import { getWeatherCondition, Weather } from "@/models/weather";

type Props = {
  weather: Weather;
};

export const WeatherIcon = ({ weather }: Props) => {
  return <img className="w-[30px] h-[30px]" src={getWeatherCondition(weather.weather_condition).icon} alt="weather" />;
};
